import * as angular from "angular";
import { directivesModule } from "../directivesModule";
import "./LayoutController";
import "./LayoutDirective";
import "./PhoneSplashScreenDirective";

class SinglePaneLayoutComponent implements angular.IComponentOptions {
	bindings: any = {
		bvTitle: '@',
		appContext: '<',
		contextchanged: '&?',
		tabs: '<',
		selectedTab: '<',
		tabchanged: '&?',
		preventPhones:'<',
	};

	transclude: any = {
		'panecenter': 'panecenter'
	};

	public controller: string = 'bvPaneController';
	public controllerAs: string = 'layoutVM';
	public templateUrl: string = '/Common/Layout/_singlePanelTemplate.html';

}

directivesModule.component('bvSinglePane', new SinglePaneLayoutComponent()); 


// WEBPACK FOOTER //
// ./Common/Layout/SinglePaneLayout.ts